<template>
  <div class="pageNo">
    <van-empty
      class="custom-image"
      :image="require('../assets/images/pageNone.png')"
      description="抱歉，页面不见了~"
    />
  </div>
</template>
<script type="text/ecmascript-6">
import { toast } from "@/common/api/api.js";
export default {
  data() {
    return {};
  },
  mounted() {
    this.init();
  },
  methods: {
    init() {}
  }
};
</script>
<style lang="stylus" type="stylesheet/stylus" scoped>
@import '../assets/stylus/common.styl';

.pageNo {
  position: absolute;
  top: 0;
  bottom: 0;
  width: 100%;
  background: #fff;
  >>>.van-empty {
    padding: 60px;
  }
  >>>.van-empty__image {
    width: 120px;
    height: 120px;
  }
}
</style>